export default "__VITE_ASSET__JUCg11CY__"